export const PROFILE_SECTION_EMPLOYEE = 0;
export const PROFILE_SECTION_CANDIDATE = 1;
export const PROFILE_SECTION_CANDIDATE_SHORT = 2;
